/* *********************************
 *
 *      画面遷移用空ページ
 *
 ********************************* */
/*-------------------
     モジュールのimport
 ---------------------*/
import React from 'react';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import axios from 'axios';

/*-------------------
     定数のimport
  ---------------------*/
import { API_PATH } from '../constant/constant';

/**
 * 画面遷移用空ページ
 */
class EmptyPage extends Component {
  constructor(props) {
    super(props);

    this.state = { tikuA: false, tikuB: false, tikuC: false };
  }

  /**
   *一度目の描画終了時に実行される
   *
   * @memberof EmptyPage
   */
  componentDidMount = async () => {};

  test = async () => {
    const { tikuA, tikuB, tikuC } = this.state;

    const array = [];
    if (tikuA === true) array.push('A');
    if (tikuB === true) array.push('B');
    if (tikuC === true) array.push('C');

    if (array.length === 0) {
      window.alert('地区を一つは選択して下さい。');
      return;
    }

    // DBに地区情報を設定する。
    axios
      .post(`${API_PATH}/v/test/sd/ln`, { array })
      .then(() => {
        window.alert('送信しました。');
      })
      .catch(() => {
        window.alert('送信に失敗しました。');
      });
  };

  /**
   *画面遷移用空ページ
   *
   * @memberof DraftConfirmation
   */
  render() {
    const { tikuA, tikuB, tikuC } = this.state;
    return (
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <div style={{ marginBottom: '20px' }}>送信する地区を撰んで下さい。</div>
        <div>
          <label htmlFor="id01">
            <input
              type="checkbox"
              id="id01"
              onChange={() => {
                this.setState({ tikuA: !tikuA });
              }}
            />
            &nbsp; 地区A
          </label>
        </div>
        <div>
          <label htmlFor="id02">
            <input
              type="checkbox"
              id="id02"
              onChange={() => {
                this.setState({ tikuB: !tikuB });
              }}
            />
            &nbsp; 地区B
          </label>
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label htmlFor="id03">
            <input
              type="checkbox"
              id="id03"
              onChange={() => {
                this.setState({ tikuC: !tikuC });
              }}
            />
            &nbsp; 地区C
          </label>
        </div>
        &emsp;
        <button onClick={() => this.test()}>送信</button>
      </div>
    );
  }
}

EmptyPage.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    path: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
};
export default withRouter(EmptyPage);
